/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_SourceInputs */

const en_md_source = /** @type {(inputs: Md_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const id_md_source = /** @type {(inputs: Md_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Md_SourceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_source = /** @type {((inputs?: Md_SourceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_SourceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_source(inputs)
	return en_md_source(inputs)
});